/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './content-overlay-container.html';

import { $root } from '../../../player/player';
import { mixinType } from '../../../util.type';
import ContentOverlay from './content-overlay';

import ScheduleContent, { ContentType } from '../../schedule/schedule-content';

/**
 * @import { PropType } from 'vue'
 * @import { Overlay, OverlayStyle } from '.'
 * @import { Layer } from '../../layer/layer'
 * @import { Content } from '../content'
 * @import { ContentInfo } from '../info/content-info'
 */

/**
 * Kontejner pro dynamické renderování content overlay vrstiev.
 * Naslouchá událostem z ViewerManager a vytváří ContentOverlay komponenty.
 */
export default defineComponent({
  name: 'ContentOverlayContainer',
  template,
  components: { ContentOverlay },
  computed: {
    swipeEnabled() {
      return (
        this.swipeEnabledDefault ||
        this.contentInfo?.communicatorSettings.get(
          'player.light.playlist.gesture.swipeNextEnable'
        ) === 'true'
      );
    }
  },
  created() {
    this.onContent = this.onContent.bind(this);
  },
  mounted() {
    $root(this).viewerManager.on('content', this.onContent);
  },
  data() {
    return mixinType(
      {
        /** @type {Overlay[]} */ overlays: []
      },
      {}
    );
  },
  destroyed() {
    // Zrušení naslouchání událostem.
    $root(this).viewerManager.off('content', this.onContent);
  },
  methods: {
    /**
     * @param {Content | null} content
     */
    onContent(content) {
      this.overlays = [];
      if (content === null || !this.swipeEnabled) {
        return;
      }
      switch (ScheduleContent.type(content)) {
        case ContentType.Playlist:
          if (content.playlist?.deterministic) {
            break;
          }
          this.overlays = [
            {
              style: {
                position: 'absolute',
                height: '100%',
                width: '100%',
                top: '0',
                left: '0',
                zIndex: '999'
              },
              content
            }
          ];
          break;
        case ContentType.Layout:
          this.overlays =
            content.layout?.layers
              .filter(
                (layer) =>
                  layer.playlist?.id !== undefined &&
                  !layer.playlist.deterministic
              )
              .map((layer) => ({
                content: layer,
                style: this.overlayFromLayer(layer)
              })) ?? [];
          break;
        default:
          break;
      }
    },
    /**
     * @param {Pick<Layer, 'top' | 'left' | 'width' | 'height' | 'zIndex'>} layer
     * @returns {OverlayStyle}
     */
    overlayFromLayer(layer) {
      return {
        position: 'absolute',
        top: layer.top,
        left: layer.left,
        width: layer.width,
        height: layer.height,
        zIndex: layer.zIndex
      };
    }
  },
  props: {
    contentInfo: {
      /** @type {PropType<ContentInfo | null>} */
      type: Object,
      required: false
    },
    swipeEnabledDefault: {
      type: Boolean,
      default: true
    },
    playbackControlsEnabled: {
      type: Boolean,
      default: true
    }
  },
  emits: {}
});
